import type { V2SessionType } from '@/features/sessions/types'
import { ROUTES } from '@/utils/config/constants'

export function getMeetingLink(session: V2SessionType) {
  return `${window.location.origin}${ROUTES.DASHBOARD}?meetingRoomId=${session.meetingRoomId}`
}
